/**
 * 1stdibs
 * User: James
 * Date: 1/17/14
 */
"use strict";

var SoaCollection = require('bunsen/collections/SoaCollection');

/**
 * @class Categories
 * @extends SoaCollection
 */
var Categories = module.exports = SoaCollection.extend();

var Category = require('bunsen/models/inventory/Category');
var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var dataProvider = require('bunsen/helpers/dataProvider');
var getDeferredMethods = require('bunsen/helpers/getDeferredMethods');
var globalCache = require('bunsen/helpers/globalCache');

var deferred = getDeferredMethods().Deferred;

var cacheKey = Symbol('fetching_categories');

var find = function findBy(coll, field, value) {
    var i = -1;
    var len = coll.length;
    var children;
    var res;

    while (++i < len) {
        res = coll.models[i].get(field);
        if (value === res) {
            return coll.models[i];
        }
        children = coll.models[i].get('children');
        if (children) {
            res = find(children, field, value);
            if (res) {
                return res;
            }
        }
    }
    return undefined;
};

_.extend(Categories.prototype, /** @lends Categories.prototype */{
    model: Category,
    url: endpoints.categories,
    comparator: 'name',
    defaultParams: {
        hideInactive: 'Y'
    },
    /**
     * @deprecated
     * @public
     * @param {string} code A category's 'code' attribute'
     * @returns {Category}
     */
    findByCode: function (code) {
        return find(this, 'code', code);
    },
    /**
     * @public
     * @param {string} key A category's 'key' attribute'
     * @returns {Category}
     */
    findByKey: function (key) {
        return find(this, 'key', key);
    }

});

Categories.setDefaultComparator = function (comparator) {
    Categories.prototype.comparator = comparator;
};

/**
 * @public
 * @static
 * @memberOf Categories
 * @returns {Categories}
 */
Categories.allCategoriesInstance = function () {
    if (!Categories._allCategoriesInstance) {
        Categories._allCategoriesInstance = new Categories();
    }
    return Categories._allCategoriesInstance;
};

/**
 * @public
 * @static
 * @memberOf Categories
 * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch
 * @returns {Deferred.promise}
 */
Categories.fetchAllCategoriesInstance = function (fetchOptions) {
    var allCategoriesPromise = globalCache.get(cacheKey);
    if (!allCategoriesPromise) {
        fetchOptions = fetchOptions ? _.clone(fetchOptions) : {};
        fetchOptions.data = fetchOptions.data || { fields: 'descendants,dimensionSet' };
        allCategoriesPromise = Categories.allCategoriesInstance().fetch(fetchOptions);
        globalCache.set(cacheKey, allCategoriesPromise);
        allCategoriesPromise.fail(function () {
            globalCache.del(cacheKey);
        });
    }
    return allCategoriesPromise;
};

/**
 * @public
 * @static
 * @memberOf Categories
 * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch
 * @param {string} [dataProviderKey]
 *     Key used to retrieve data from the dataProvider for the 'all' Categories singleton
 * @returns {Deferred.promise}
 */
Categories.requestAllCategoriesUseDP = function (fetchOptions, dataProviderKey) {
    var data = dataProvider.get(dataProviderKey || 'categories');
    if (data) {
        Categories.allCategoriesInstance().reset(data);
        return deferred().resolve(data).promise();
    }
    return Categories.fetchAllCategoriesInstance(fetchOptions);
};



// WEBPACK FOOTER //
// ./~/bunsen/collections/inventory/Categories.es.js